import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
} from '@chakra-ui/react';

function EmailField({
    label = 'Email',
    isRequired = true,
    field,
    form,
    ...inputProps
}) {
    const isInvalid = Boolean(
        form.errors[field.name] && form.touched[field.name],
    );

    return (
        <FormControl isRequired={isRequired} isInvalid={isInvalid}>
            <FormLabel htmlFor={field.name}>{label}</FormLabel>
            <Input
                {...field}
                id={field.name}
                placeholder="Enter your email"
                type="email"
                autoComplete="email"
                borderColor="gray.300"
                _placeholder={{ color: 'gray.400' }}
                {...inputProps}
            />
            <FormErrorMessage fontSize="sm" mt={1}>
                {form.errors[field.name]}
            </FormErrorMessage>
        </FormControl>
    );
}

export { EmailField };
